import { ComponentType, SVGProps } from 'react';
import PdfIcon from './fileIcons/pdf.svg?react';

const FILE_ICON_COMPONENTS = {
    pdf: PdfIcon,
} as const satisfies Record<string, ComponentType<SVGProps<SVGSVGElement>>>;

export type FileIconType = keyof typeof FILE_ICON_COMPONENTS;

export const FILE_ICON_TYPES = Object.keys(
    FILE_ICON_COMPONENTS,
) as FileIconType[];

export interface FileIconProps {
    type: FileIconType;
    size?: number | string;
}

export const FileIcon = ({ type, size = 24 }: FileIconProps) => {
    const Icon = FILE_ICON_COMPONENTS[type];

    return <Icon width={size} />;
};
